import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bgGetMemberBodyList = async function(userId, docId) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');
  let query = `
    select 
      * ,
      FORMAT_DATE('%d/%b/%y', DATE(H.date)) dateFormated,
      concat(U.firstname, ' ', U.lastname) createdName 
    from 
       thaisook_view.healthdata H
      left join thaisook_view.users U
        on U.uid = H.createdBy
    where 
      H.category='fat'
      and H.source='coach'
      and H.uid='${userId}'
`;
  if( docId != undefined ){
    query = `
      select 
        * 
      from 
         thaisook_view.healthdata 
      where 
        docId = '${docId}'
    `;
  }
  const result = await queryThaisookViewBigQuery({
    info: 'get member body list',
    query: query
  });
  const resultObj = JSON.parse(result.data);
  return resultObj
};
export default bgGetMemberBodyList;
